import React, { useState } from 'react';
import './PricingSummary.css';

const PricingSummary = ({ pricing, formatPrice }) => {
  const [isOpen, setIsOpen] = useState(() => {
    if (typeof window !== 'undefined') {
      return window.innerWidth >= 900;
    }
    return true;
  });

  if (!pricing) {
    return null;
  }

  return (
    <div className="pricing-summary-container" id="pricing-summary-section">
      <button
        className="pricing-summary-toggle"
        onClick={() => setIsOpen(!isOpen)}
        type="button"
        aria-expanded={isOpen}
      >
        <span>Pricing Breakdown</span>
        <span className="toggle-icon">{isOpen ? '▼' : '▶'}</span>
      </button>

      {isOpen && (
        <div className="pricing-summary-content">
          <div className="pricing-row">
            <span className="pricing-label">Base Price:</span>
            <span className="pricing-value">{formatPrice(pricing.breakdown.basePrice)}</span>
          </div>
          <div className="pricing-row">
            <span className="pricing-label">Customizations:</span>
            <span className="pricing-value">{formatPrice(pricing.breakdown.modifications)}</span>
          </div>
          <div className="pricing-row total">
            <span className="pricing-label">Total Price:</span>
            <span className="pricing-value">{formatPrice(pricing.totalPrice)}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default PricingSummary;
